import { FlexBox, Text } from '@trmediaab/zebra';

import InfoBadge from '~/components/InfoBadge';
import { ThemedLink } from '~/components/ThemedLink';
import { formatRoundDate } from '~/utils/round';

export default function RoundItem({ round }) {
  const date = new Date(round.start_time);
  return (
    <ThemedLink
      to={{
        type: 'ROUND_TIP',
        payload: {
          bet_type: round.bet_type.toLowerCase(),
          slug: round.slug,
        },
      }}
      sx={{
        display: 'block',
        "&:hover [data-id='headline'] ": {
          textDecoration: 'underline',
        },
      }}
    >
      <FlexBox
        flexDirection="row"
        bg="white"
        px="3"
        py="3"
        gap="3"
        alignItems="center"
      >
        <InfoBadge px="1" bg={`atg.${round.bet_type}.primary`} color="white">
          <Text width="32px" textAlign="center" fontWeight="bold">
            {round.bet_type.toUpperCase()}
          </Text>
        </InfoBadge>

        <Text
          fontWeight="semiBold"
          color="brands.travrondenSpel"
          lineHeight="tight"
          fontSize={2}
          data-id="headline"
        >
          {round.track_name.replace('/', ' / ')}{' '}
          {formatRoundDate(date).toLowerCase()}
        </Text>
      </FlexBox>
    </ThemedLink>
  );
}
